import { CommonModule } from '@angular/common';
import { Component, HostBinding, Input } from '@angular/core';

type AuditAlign = 'start' | 'center' | 'end';

@Component({
  selector: 'app-custom-audit-info',
  templateUrl: './custom-audit-info.component.html',
  styleUrls: ['./custom-audit-info.component.scss'],
  standalone: true,
  imports: [CommonModule]
})
export class CustomAuditInfoComponent {

  @Input() userNameCreate: string | null = null;
  @Input() createDate: string | Date | null = null;
  @Input() userNameUpdate: string | null = null;
  @Input() updateDate: string | Date | null = null;
  @Input() dateFormat: string = 'dd/MM/yyyy hh:mm a';
  @Input() reserveSpace: boolean = false;
  @Input() hideContent: boolean = false;
  @Input() emptyText: string = '—';
  @Input() labelCreate: string = 'Creado';
  @Input() labelUpdate: string = 'Modificado';
  @Input() showIcons: boolean = true;
  @Input() align: AuditAlign = 'end';
  /** Ancho máximo del nombre de usuario; el exceso se recorta con elipsis. */
  @Input() userNameWidth: string = '10rem';
  /** Ancho mínimo reservado para la fecha (`0` = ajustada al contenido). */
  @Input() dateWidth: string = '0';

  private readonly alignMap: Record<AuditAlign, string> = {
    start: 'flex-start',
    center: 'center',
    end: 'flex-end',
  };

  @HostBinding('style.--audit-name-width') get nameWidthVar(): string {
    return this.userNameWidth;
  }

  @HostBinding('style.--audit-date-width') get dateWidthVar(): string {
    return this.dateWidth;
  }

  @HostBinding('style.--audit-align') get alignVar(): string {
    return this.alignMap[this.align] ?? this.alignMap.end;
  }

  get hasData(): boolean {
    return !!this.userNameCreate;
  }

  get visible(): boolean {
    return this.hasData && !this.hideContent;
  }

  get reserving(): boolean {
    return !this.visible && this.reserveSpace;
  }

  get showUpdate(): boolean {
    return !!this.userNameUpdate;
  }
}
